import _classPrivateFieldLooseBase from "/data/jenkins_home/workspace/JOINMC-HTML-MASTER/node_modules/@babel/runtime/helpers/esm/classPrivateFieldLooseBase.js";
import _classPrivateFieldLooseKey from "/data/jenkins_home/workspace/JOINMC-HTML-MASTER/node_modules/@babel/runtime/helpers/esm/classPrivateFieldLooseKey.js";
import "core-js/modules/es.array.push.js";
import qs from "qs";
import { MessageBox } from "element-ui";
import SocketEventCenter from "./SocketEventCenter";
import { tokenExpired } from "@/router/tokenExpired";
import router from "@/router";

// 全局WebSocket连接管理器
class WebSocketConnectionManager {
  constructor() {
    this.connections = new Map();
  }
  addConnection(key, wsInstance) {
    this.connections.set(key, wsInstance);
  }
  removeConnection(key) {
    const ws = this.connections.get(key);
    // console.log("removeConnection", ws);
    if (ws && ws.socket) {
      ws.socket.close();
    }
    // if (ws) {
    //   ws.close();
    // }
    this.connections.delete(key);
  }
  closeAllConnections() {
    // console.log(this.connections);
    for (const [, ws] of this.connections) {
      // 兜底判空：某个实例的 socket 可能已为空，避免整个关闭流程被中断
      if (ws && ws.socket) {
        ws.socket.close();
      }
    }
    this.connections.clear();
  }
  getConnectionCount() {
    return this.connections.size;
  }
}
export const globalWebSocketManager = new WebSocketConnectionManager();
var _reconnectAttempts = /*#__PURE__*/_classPrivateFieldLooseKey("reconnectAttempts");
var _lastOpenedAt = /*#__PURE__*/_classPrivateFieldLooseKey("lastOpenedAt");
var _hasOpened = /*#__PURE__*/_classPrivateFieldLooseKey("hasOpened");
var _pingIntervalId = /*#__PURE__*/_classPrivateFieldLooseKey("pingIntervalId");
var _manualShutDown = /*#__PURE__*/_classPrivateFieldLooseKey("manualShutDown");
var _MAX_RECONNECT_ATTEMPTS = /*#__PURE__*/_classPrivateFieldLooseKey("MAX_RECONNECT_ATTEMPTS");
var _RECONNECT_INTERVAL = /*#__PURE__*/_classPrivateFieldLooseKey("RECONNECT_INTERVAL");
var _PING_INTERVAL = /*#__PURE__*/_classPrivateFieldLooseKey("PING_INTERVAL");
var _onOpen = /*#__PURE__*/_classPrivateFieldLooseKey("onOpen");
var _onError = /*#__PURE__*/_classPrivateFieldLooseKey("onError");
var _onClose = /*#__PURE__*/_classPrivateFieldLooseKey("onClose");
var _shouldReconnect = /*#__PURE__*/_classPrivateFieldLooseKey("shouldReconnect");
var _onMessage = /*#__PURE__*/_classPrivateFieldLooseKey("onMessage");
var _sendPing = /*#__PURE__*/_classPrivateFieldLooseKey("sendPing");
var _reconnectIfNeeded = /*#__PURE__*/_classPrivateFieldLooseKey("reconnectIfNeeded");
export default class WebSocketManager {
  constructor(url, param, {
    onMessage,
    onOpen,
    onReconnect,
    emitGlobal = true
  } = {}) {
    Object.defineProperty(this, _reconnectIfNeeded, {
      value: _reconnectIfNeeded2
    });
    this.socket = null;
    Object.defineProperty(this, _reconnectAttempts, {
      writable: true,
      value: 0
    });
    Object.defineProperty(this, _lastOpenedAt, {
      writable: true,
      value: 0
    });
    // 上次成功建立连接的毫秒时间戳，用于识别“连上即断”的异常连接
    Object.defineProperty(this, _hasOpened, {
      writable: true,
      value: false
    });
    // 只有曾建立过连接，再次打开才算断线重连
    Object.defineProperty(this, _pingIntervalId, {
      writable: true,
      value: null
    });
    Object.defineProperty(this, _manualShutDown, {
      writable: true,
      value: false
    });
    Object.defineProperty(this, _MAX_RECONNECT_ATTEMPTS, {
      writable: true,
      value: 10
    });
    Object.defineProperty(this, _RECONNECT_INTERVAL, {
      writable: true,
      value: 1000
    });
    Object.defineProperty(this, _PING_INTERVAL, {
      writable: true,
      value: 30000
    });
    Object.defineProperty(this, _onOpen, {
      writable: true,
      value: () => {
        const reconnected = _classPrivateFieldLooseBase(this, _hasOpened)[_hasOpened];
        _classPrivateFieldLooseBase(this, _hasOpened)[_hasOpened] = true;
        // 真正的连接建立时只打印一次，避免服务端消息推送时刷屏。
        console.debug(`${this.funcName} socket 已建立连接`);
        // 仅当连接稳定保持一段时间后才重置重连计数，防止“连上即断”导致无限重连风暴
        // （每次重连服务端都可能重推一批消息，造成日志刷屏和主线程卡顿）。
        if (Date.now() - _classPrivateFieldLooseBase(this, _lastOpenedAt)[_lastOpenedAt] > 10000) {
          _classPrivateFieldLooseBase(this, _reconnectAttempts)[_reconnectAttempts] = 0;
        }
        _classPrivateFieldLooseBase(this, _lastOpenedAt)[_lastOpenedAt] = Date.now();
        if (_classPrivateFieldLooseBase(this, _pingIntervalId)[_pingIntervalId]) clearInterval(_classPrivateFieldLooseBase(this, _pingIntervalId)[_pingIntervalId]); // 清理可能存在的心跳定时器
        _classPrivateFieldLooseBase(this, _sendPing)[_sendPing]();
        if (reconnected) this.onReconnect?.();else this.onOpen?.();
      }
    });
    Object.defineProperty(this, _onError, {
      writable: true,
      value: error => {
        // console.error(`${this.funcName} websocket encountered an error:`, error);
        if (_classPrivateFieldLooseBase(this, _shouldReconnect)[_shouldReconnect]()) {
          _classPrivateFieldLooseBase(this, _reconnectIfNeeded)[_reconnectIfNeeded]();
        }
      }
    });
    Object.defineProperty(this, _onClose, {
      writable: true,
      value: () => {
        // console.error(`${this.funcName} websocket onClosed`);
        clearInterval(_classPrivateFieldLooseBase(this, _pingIntervalId)[_pingIntervalId]);
        _classPrivateFieldLooseBase(this, _pingIntervalId)[_pingIntervalId] = null;
        if (_classPrivateFieldLooseBase(this, _shouldReconnect)[_shouldReconnect]()) {
          _classPrivateFieldLooseBase(this, _reconnectIfNeeded)[_reconnectIfNeeded]();
        }
      }
    });
    Object.defineProperty(this, _shouldReconnect, {
      writable: true,
      value: () => {
        // 显式关闭优先，任何页面/登录态下都不再重连
        if (_classPrivateFieldLooseBase(this, _manualShutDown)[_manualShutDown]) return false;
        if (localStorage.getItem("token")) return true;
        // 公共插码页无需登录，保持原有保活逻辑
        return location.pathname === "/chatBotInsertion";
      }
    });
    Object.defineProperty(this, _onMessage, {
      writable: true,
      value: event => {
        if (event.data) {
          let data = JSON.parse(event.data);
          if (data.code == 20001) {
            // Token 已过期，关闭连接统一交给 tokenExpired 里的 closeAllConnections 处理
            tokenExpired();
            router.push("/homepage");
          } else {
            if (this.emitGlobal) SocketEventCenter.emit(this.funcName, data);
            this.onMessage?.(data);
          }
        }
      }
    });
    Object.defineProperty(this, _sendPing, {
      writable: true,
      value: () => {
        const pingMessage = JSON.stringify(this.param);
        _classPrivateFieldLooseBase(this, _pingIntervalId)[_pingIntervalId] = setInterval(() => {
          if (this.socket && this.socket.readyState === WebSocket.OPEN) {
            this.socket.send(pingMessage);
          }
        }, _classPrivateFieldLooseBase(this, _PING_INTERVAL)[_PING_INTERVAL]);
      }
    });
    this.url = `${url}?${qs.stringify(param)}`;
    this.funcName = param.func_name;
    this.param = param;
    // 页面可独立监听本连接并关闭全局广播；旧调用默认仍使用事件中心。
    this.onMessage = onMessage;
    // 首次建连也可能晚于 REST 初始化；独立回调供页面补齐这段时间的推送空档。
    this.onOpen = onOpen;
    // 断线重连沿用原有回调，避免改变其他页面对重连事件的判断。
    this.onReconnect = onReconnect;
    this.emitGlobal = emitGlobal;
    this.connectionKey = `${param.func_name}_${Date.now()}_${Math.random().toString(36).substr(2, 9)}`;

    // 自动注册到全局管理器
    globalWebSocketManager.addConnection(this.connectionKey, this);
  }
  connect() {
    if (this.socket) {
      this.socket.close();
      this.socket = null;
    }
    if (_classPrivateFieldLooseBase(this, _reconnectAttempts)[_reconnectAttempts] >= _classPrivateFieldLooseBase(this, _MAX_RECONNECT_ATTEMPTS)[_MAX_RECONNECT_ATTEMPTS]) {
      // console.error(`${this.funcName}达到最大重连次数`);
      if (_classPrivateFieldLooseBase(this, _pingIntervalId)[_pingIntervalId]) clearInterval(_classPrivateFieldLooseBase(this, _pingIntervalId)[_pingIntervalId]);
      MessageBox.alert("由于长时间未操作或网络波动，请稍后刷新重试！", "提示", {
        type: "warning",
        confirmButtonText: "确定"
      }).then(() => window.location.reload());
      return;
    }
    _classPrivateFieldLooseBase(this, _reconnectAttempts)[_reconnectAttempts]++;

    // console.log(`${this.funcName}: Attempting to establish websocket connection (Attempt ${this.#reconnectAttempts})`);

    this.socket = new WebSocket(this.url);
    this.socket.onopen = _classPrivateFieldLooseBase(this, _onOpen)[_onOpen];
    this.socket.onmessage = _classPrivateFieldLooseBase(this, _onMessage)[_onMessage];
    this.socket.onerror = _classPrivateFieldLooseBase(this, _onError)[_onError];
    this.socket.onclose = _classPrivateFieldLooseBase(this, _onClose)[_onClose];
  }
  send(message) {
    if (this.socket && this.socket.readyState === WebSocket.OPEN) {
      this.socket.send(JSON.stringify(message));
    } else {
      this.connect();
    }
  }
  close() {
    _classPrivateFieldLooseBase(this, _manualShutDown)[_manualShutDown] = true;
    if (this.socket) {
      this.socket.close();
      this.socket = null;
    }
    // 建连失败时 socket 也可能为空，仍需从全局管理器移除当前实例。
    globalWebSocketManager.removeConnection(this.connectionKey);
  }
}
function _reconnectIfNeeded2() {
  if (this.socket && this.socket.readyState !== WebSocket.CLOSED) {
    return; // 如果当前连接未关闭，不进行重连
  }
  if (_classPrivateFieldLooseBase(this, _reconnectAttempts)[_reconnectAttempts] < _classPrivateFieldLooseBase(this, _MAX_RECONNECT_ATTEMPTS)[_MAX_RECONNECT_ATTEMPTS]) {
    setTimeout(() => {
      // 页面切换或卸载可能发生在重连计时期间，显式关闭后不再创建旧会话连接。
      if (!_classPrivateFieldLooseBase(this, _shouldReconnect)[_shouldReconnect]()) return;
      // error 与 close 都可能排队重连；已有连接时只保留先执行的那一次。
      if (this.socket && this.socket.readyState !== WebSocket.CLOSED) return;
      this.connect();
    }, _classPrivateFieldLooseBase(this, _RECONNECT_INTERVAL)[_RECONNECT_INTERVAL]);
  }
}